module.exports = "/images/vendor/desiigner-svg/svg/places/brain.svg?af71eb896e804aaa53cbc9f64339dcf9";